// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._0zkeoA6ER4r0sGk3Obo8ZA\\=\\=>div>ul{margin-top:.5rem !important;margin-bottom:0 !important}", "",{"version":3,"sources":["webpack://./components/skeletons/TextSkeleton/styles.module.scss"],"names":[],"mappings":"AACE,oCACE,2BAAA,CACA,0BAAA","sourcesContent":[".container {\n  > div > ul {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_0zkeoA6ER4r0sGk3Obo8ZA=="
};
export default ___CSS_LOADER_EXPORT___;
